import {BaseDTO} from './_baseDTO.interface';
import {BodyPartDTO} from './bodyPartDTO.interface';
import {BaseIntDTO} from "./_baseIntDTO.interface";

export interface BodyPartGroupDTO extends BaseIntDTO {
  groupName: string;
  bodyParts: BodyPartDTO[];
}
